module.exports = __webpack_public_path__ + "img/B265.7ae84a2c.png";